<template>
  <header class="palette--header">
    <h1>{{title}}</h1>
    <h2>{{color}}</h2>
  </header>
</template>

<script>
export default {
  name: 'Title',
  props: {
    title: String,
    color: String,
  },
}
</script>

<style scoped>
  header {
    position: fixed;
    color:  var(--c-background-contrast);
    padding: 3.5rem 4rem;
    width: 40%;
  }
  h1 {
    font-size: 6rem;
    font-weight: 700;
    text-shadow: 0 0 0 transparent;
    transition: 600ms text-shadow;  
  }
  h2 {
    font-size: 2.5rem;
    font-weight: 100;
    margin-top: .75rem;
  }
</style>
